import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiGridColTwo } from "../../../../library/layout/Index";

const LocationHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '550px' }}
            contentStyle={{ width: "800px" }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >
            <UiGridColTwo>
                <div className="uiCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locId" }} value="Location ID" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "locId" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locName" }} value="Location Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "locName" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "LocCode" }} value="Location Code" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "LocCode" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "nickName" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Address" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className="uiVal uiVal50p"
                                action={{ paramName: "address" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesOrderBG" }} value="Sales Order BG" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "salesOrderBG", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesOrderCC" }} value="Sales Order CC" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "salesOrderCC", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesInvoiceBG" }} value="Sales Invoice BG" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "salesInvoiceBG", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesInvoiceCC" }} value="Sales Invoice CC" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "salesInvoiceCC", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "length" }} value="Length" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "length" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "breadth" }} value="Breadth" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "breadth" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "height" }} value="Height" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "height" }} className="uiVal uiVal50p" />
                        </li>
                    </ul>
                </div>
                <div className="uiCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "parentLoc" }} value="Parent Location" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                        action={{ InputType: "ac", paramName: "parentLoc", acMethod: "Location" }} 
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pLocType" }} value="Location Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "pLocType", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locGroup" }} value="Location Group" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "locGroup", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locCountry" }} value="Location Country" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "locCountry", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "styleAttr" }} value="Style Attribute" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "styleAttr" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortNo" }} value="Sort No" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "sortNo" }} className="uiVal uiVal50p" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditNoteBG" }} value="Credit Note BG" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "creditNoteBG", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditNoteCC" }} value="Credit Note CC" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "creditNoteCC", gid: "full", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Is Active ?" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "isActive" }} />

                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isExternal" }} value="Is External ?" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "isExternal" }} />
                                <SarasTrans value="(Inventory tracking is disabled for external locations)" />
                            </div>
                            <div>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isStorage" }} value="Is Storage ?" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "isStorage" }} />
                                <SarasTrans value="(Inventory tracking is disabled for Storage locations)" />
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "showOnApp" }} value="Show On App ?" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "showOnApp" }} />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "showOnReport" }} value="Show On Report ?" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "showOnReport" }} />
                        </li>
                    </ul>
                </div>
            </UiGridColTwo>
        </FormDialog>
    )
}

export default withView(LocationHeaderEditor, "locationHeader", "locationHeader")